import React, {useEffect} from "react"

interface TaxProps {
	taxedValue: number
	untaxedValue: number
	fractionDigits: number
	currency?: string
}

export default function Tax(props: TaxProps) {
	const [power, setPower] = React.useState(2)
	const [currency, setCurrency] = React.useState("€")

	function getCountry() {
		setPower(props.fractionDigits)
		props.currency ? setCurrency(props.currency) : setCurrency("€")
	}
	useEffect(() => getCountry())

	const value: number = props.taxedValue - props.untaxedValue
	let floatValue = Number.parseFloat(value.toString())

	let formattedPrice = (floatValue / Math.pow(10, power)).toFixed(power)

	return (
		<div style={{fontWeight: 300, color: "gray", fontSize: "11px"}}>
			<div style={{fontWeight: "bold", display: "inline-block"}}>Taxes</div> {currency}{" "}
			{formattedPrice}
		</div>
	)
}
